import Skeleton from "../../common/Skeleton";

const InsiderStateCardSkeleton = () => {
  return (
    <>
      {/* Mobile Layout Skeleton */}
      <div className="block lg:hidden">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 p-4">
          {[...Array(3)].map((_, index) => (
            <div
              key={index}
              className="flex sm:flex-row items-start sm:items-center gap-3 sm:gap-2 space-y-2 sm:space-y-0 sm:space-x-3 bg-gray-100 dark:bg-gray-800/50 rounded-lg p-3 sm:p-4 lg:p-5 border border-gray-200 dark:border-gray-700/50"
            >
              <div className="p-[5px] rounded-full bg-gray-200 dark:bg-gray-700 flex-shrink-0">
                <Skeleton className="w-4 h-4 rounded" />
              </div>
              <div className="min-w-0 flex items-center gap-2">
                <div>
                  <Skeleton className="w-24 h-4 rounded mb-2" />
                  <Skeleton className="w-20 h-6 rounded" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop Layout Skeleton */}
      <div className="hidden lg:flex justify-between items-center border border-[#d0d4e4] dark:border-[#394564] rounded-md bg-white my-0 !mt-0 dark:bg-[#121419] w-full shadow-[5px_1px_5px_rgba(0,0,0,0.09)]">
        <div className="flex items-center justify-between w-full py-4">
          {[...Array(3)].map((_, index) => {
            const isLast = index === 2;
            return (
              <div
                key={index}
                className={`flex items-start space-x-3 flex-1 px-4 py-0 justify-start ${!isLast ? "border-r border-[#d0d4e4] dark:border-gray-700" : ""}`}
              >
                <div className="p-[5px] rounded-full bg-gray-200 dark:bg-gray-700 flex-shrink-0">
                  <Skeleton className="w-4 h-4 rounded" />
                </div>
                <div className="flex items-center gap-2">
                  <div>
                    <Skeleton className="w-32 h-4 rounded mb-1" />
                    <Skeleton className="w-24 h-6 rounded" />
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default InsiderStateCardSkeleton;
